<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <el-input size="medium" disabled :placeholder="placeholder"/>
      <div style="margin-top: 15px" v-show="showChinese">
        <span>大写：</span>
        <span class="chinese">{{chinese}}</span>
      </div>
    </div>
    <div v-else-if="mode === 'PC' && !readonly">
      <el-input-number style="width: 100%;" :min="0" controls-position="right" :precision="precision" size="medium" clearable v-model="_value" :placeholder="placeholder"/>
      <div v-show="showChinese">
        <span>大写：</span>
        <span class="chinese">{{chinese}}</span>
      </div>
    </div>
    <div v-else-if="mode === 'MOBILE' && !readonly">
      <field v-model="_value" type="number" :placeholder="placeholder"/>
      <div v-show="showChinese">
        <span style="color:#656363;">大写：</span>
        <span class="chinese">{{chinese}}</span>
      </div>
    </div>
    <div v-else>
      {{ displayValue }}
      <span style="margin-left: 30px" v-show="showChinese">
        <span style="color:#656363;">大写：</span>
        <span class="chinese">{{chinese}}</span>
      </span>
    </div>
  </div>
</template>

<script>
import {NumberKeyboard, Field } from 'vant'
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: "AmountInput",
  components: {NumberKeyboard, Field},
  props: {
    value: {
      type: Number,
      default: undefined
    },
    placeholder: {
      type: String,
      default: '请输入金额'
    },
    showChinese: {
      type: Boolean,
      default: true
    },
    precision: {
      type: Number,
      default: 0
    }
  },
  computed:{
    chinese(){
      if (!this.value || isNaN(this.value) || this.value === 0) {
        return ''
      }
      return this.convertCurrency(this.value)
    },
    _value:{
      get(){
        return this.parseNumber(this.value);
      },
      set(val){
        this.$emit('input', this.parseNumber(val))
      }
    },
    displayValue(){
      const v = this._value
      if (v === null || v === undefined || v === '' || (typeof v === 'number' && isNaN(v))) {
        return ''
      }
      return v
    }
  },
  data() {
    return {
      showKey: false,
      val: null
    }
  },
  created() {
    // 🔥 修复：默认不给 0，给 null，小程序不报错
    if (this.value == undefined) {
      this.value = null
    }
  },
  methods: {
    convertCurrency(money) {
      const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
      const cnIntRadice = ['', '拾', '佰', '仟'];
      const cnIntUnits = ['', '万', '亿', '兆'];
      const cnDecUnits = ['角', '分', '毫', '厘'];
      const cnInteger = '整';
      const cnIntLast = '元';
      let maxNum = 999999999999999.9999;
      let integerNum, decimalNum, chineseStr = '';
      let parts;

      // 🔥 修复：空值、null、NaN 直接返回空，小程序不报错
      if (money == null || money === '' || isNaN(money)) {
        return '';
      }

      money = parseFloat(money);
      if (money >= maxNum || money === 0) {
        return '';
      }

      money = money.toString();
      if (money.indexOf('.') === -1) {
        integerNum = money;
        decimalNum = '';
      } else {
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
      }

      if (parseInt(integerNum, 10) > 0) {
        var zeroCount = 0;
        var IntLen = integerNum.length;
        for (let i = 0; i < IntLen; i++) {
          let n = integerNum.substr(i, 1);
          let p = IntLen - i - 1;
          let q = p / 4;
          let m = p % 4;
          if (n == '0') {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0];
            }
            zeroCount = 0;
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m == 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
          }
        }
        chineseStr += cnIntLast;
      }

      if (decimalNum !== '') {
        let decLen = decimalNum.length;
        for (let i = 0; i < decLen; i++) {
          let n = decimalNum.substr(i, 1);
          if (n !== '0') {
            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
        }
      }

      if (chineseStr === '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (decimalNum === '') {
        chineseStr += cnInteger;
      }
      return chineseStr;
    },
    parseNumber(val){
      // 🔥 修复：小程序清空后返回 null，不返回 NaN
      if (val === null || val === undefined || val === '') {
        return null
      }
      if (typeof(val) === 'string'){
        return this.precision > 0 ? parseFloat(parseFloat(val).toFixed(this.precision)) : parseInt(val)
      }
      return val
    },
    isNaN(value) {
      return typeof value === 'number' && isNaN(value)
    }
  }
}
</script>

<style lang="less" scoped>
.chinese{
  color: #afadad;
  font-size: smaller;
}
/deep/ .el-input__inner{
  text-align: left;
}
</style>
